export interface ShareItem {
  id: string;
  label: string;
  /** Parte del total, 0–100. */
  percent: number;
}

export interface ShareCardProps {
  /** Rótulo en versalitas ("Categorías · septiembre"). */
  overline: string;
  items: ShareItem[];
  /** Sufijo de la frase de la barra para lectores ("49% de tu gasto"). */
  valueSuffix: string;
  emptyLabel: string;
}

/** Tarjeta mist con el peso de cada elemento: nombre, porcentaje y barra sobre pista `track-mist`. El dato va en texto, no solo en la barra. */
export function ShareCard({ overline, items, valueSuffix, emptyLabel }: ShareCardProps) {
  return (
    <div className="rounded-[var(--ds-radius-lg)] bg-[var(--ds-card-mist)] p-5 text-[var(--ds-on-card)] sm:p-6">
      <div className="text-[11px] font-medium uppercase leading-[14px] tracking-[0.06em] text-[var(--ds-on-card-muted)]">{overline}</div>
      {items.length === 0 && <p className="m-0 mt-5 text-base leading-6">{emptyLabel}</p>}
      {items.map((item) => {
        const pct = Math.max(0, Math.min(100, Math.round(item.percent)));
        return (
          <div key={item.id} className="mt-5">
            <div className="flex items-center justify-between text-base leading-6">
              <span>{item.label}</span>
              <span>{pct}%</span>
            </div>
            <div
              role="progressbar"
              aria-label={item.label}
              aria-valuemin={0}
              aria-valuemax={100}
              aria-valuenow={pct}
              aria-valuetext={`${pct}% ${valueSuffix}`}
              className="mt-2 h-2.5 overflow-hidden rounded-full bg-[var(--ds-track-mist)]"
            >
              <span className="block h-full rounded-full bg-[var(--ds-on-card)]" style={{ width: `${pct}%` }} />
            </div>
          </div>
        );
      })}
    </div>
  );
}
